export default function Hero() {
  return (
    <section className="hero text-light">
      <div className="container">
        <p className="display-6">
          Fresh<strong>Goods</strong>
        </p>
        <h1 className="display-1 pb-3">
          Concisely describe your product or service
        </h1>
        <h2 className="h2 pb-5">
          No need to get clever. Tell people exactly what you're offering, then
          use this space to communicate your key value proposition.
        </h2>
        <button type="button" className=" btn btn-warning">
          Order Now
        </button>
      </div>
    </section>
  );
}
